import { render, staticRenderFns } from "./CompanyDetailPane.vue?vue&type=template&id=684c3289&"
import script from "./CompanyDetailPane.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailPane.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailPane.vue?vue&type=style&index=0&id=684c3289&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports